import { z } from "zod";
import { omoStore } from "./omo";
import { prodStore } from "./prod";
import { PREFIX, SINGLETON_KEY } from "./storage-keys";
import { trainStore } from "./train";
import { userPrefsStore } from "./user-prefs";

const schemas = [prodStore, trainStore, omoStore, userPrefsStore];

export const validateStorage = () => {
  for (const key of Object.keys(localStorage)) {
    if (!key.startsWith(PREFIX)) continue;

    const raw = localStorage.getItem(key);
    if (!raw) continue;

    const schema = schemas.find((s) => s.storageKey === key)?.schema;
    if (!schema) {
      console.warn(`Unknown key ${key}, clearing`);
      localStorage.removeItem(key);
      continue;
    }

    const wrappedSchema = z.object({
      [`s:${SINGLETON_KEY}`]: z.object({
        versionKey: z.string(),
        data: schema,
      }),
    });

    try {
      const parsed = JSON.parse(raw);
      wrappedSchema.parse(parsed);
    } catch {
      console.warn(`Invalid data for ${key}, clearing`);
      localStorage.removeItem(key);
    }
  }
};
